// removed by extract-text-webpack-plugin
module.exports = {"commentContainer":"commentContainer___RJzVy","commentTitle":"commentTitle___2nGBF","commentBox":"commentBox___3nfWp","postComment":"postComment___2X6hw","attachFile":"attachFile___2aYIf","singleCommentContainer":"singleCommentContainer___3Sxma","commentor":"commentor___1xZsF","commentContent":"commentContent___3zUQ8","singleCommentTop":"singleCommentTop___2Wu98","commentUser":"commentUser___2707R","commentCreate":"commentCreate___3-hq2","commentMarkDown":"commentMarkDown___1pFD2","singleattachment":"singleattachment___2uY0c","attachments":"attachments___1Mint"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Comment/Comment.module.css
// module id = 225
// module chunks = 0